export default __webpack_public_path__ + "static/media/mobThrone3.ee78e3af.png";